import {
    DATA_LOADED, CUSTOMER_INFORMATION_LOADED, CUSTOMER_DEFAULT_CONTACT_PERSON
} from "../actions/mainPageActions";

export const initialState = {
    rows: [],
    customerInformation: {},
    defaultContactPerson: {}
}

export default function detailsPageReducer(state = initialState, action) {
    switch (action.type) {
        case DATA_LOADED:
            return {
                ...state,
                rows: action.payload
            }
        case CUSTOMER_INFORMATION_LOADED:
            return {
                ...state,
                customerInformation: action.payload
            }
        case CUSTOMER_DEFAULT_CONTACT_PERSON:
            return {
                ...state,
                defaultContactPerson: action.payload
            }
        default:
            return state;
    }
}